exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tableFixHead[data-v-735481b0]{overflow-y:auto;height:106px}.tableFixHead thead th[data-v-735481b0]{position:-webkit-sticky;position:sticky;top:0}table[data-v-735481b0]{border-collapse:collapse;width:100%}", ""]);

// exports
